import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import { RefObject, useRef } from 'react';
import { OrgGroupMember } from '../api/useOrgGroupMembersList';

interface IConfirmRemovalModal {
  isOpen: boolean;
  groupName: string;
  membersId: string[] | OrgGroupMember;
  onClose: () => void;
  onSuccess?: () => void;
  isLoading: boolean;
  finalFocusRef?: RefObject<HTMLElement | null>;
}

export const RemoveMemberConfirmationModal = ({
  isOpen,
  groupName,
  membersId,
  onClose,
  onSuccess,
  isLoading,
  finalFocusRef,
}: IConfirmRemovalModal) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      finalFocusRef={finalFocusRef}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            fontSize='lg'
            fontWeight='bold'
            data-testid='remove-members-header'
          >
            {Array.isArray(membersId) && membersId.length > 1
              ? 'Remove users from group'
              : 'Remove user from group'}
          </AlertDialogHeader>
          <AlertDialogBody>
            {Array.isArray(membersId) ? (
              <>
                Are you sure you want to remove <b>{membersId.length}</b>{' '}
                {membersId.length > 1 ? 'users' : 'user'} from{' '}
                <b>{groupName}</b>? If you proceed{' '}
                {membersId.length > 1 ? 'these users' : 'this user'} will fall
                back to the individual permissions.
              </>
            ) : (
              <>
                Are you sure you want to remove{' '}
                <b>
                  {membersId.givenName} {membersId.familyName}
                </b>{' '}
                from <b>{groupName}</b>? If you proceed this user will fall back
                to the individual permissions.
              </>
            )}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={onClose}
              variant='ghost'
              isDisabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              colorScheme='red'
              onClick={onSuccess}
              ml={3}
              isLoading={isLoading}
            >
              Remove
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
